import Link from "next/link";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import type { HotelDetailV2Model } from "../model/hotelDetailV2.model";

interface DetailBreadcrumbProps {
  hotel: HotelDetailV2Model;
}

export default function DetailBreadcrumb({ hotel }: DetailBreadcrumbProps) {
  return (
    <nav
      aria-label="مسیر صفحه"
      className="flex min-w-0 items-center gap-2 overflow-hidden py-3 text-sm font-medium text-[#6b7280] md:text-base"
    >
      <Link className="shrink-0 transition hover:text-primary" href="/hotel/">
        رزرو هتل
      </Link>
      <PhosphorIcon className="shrink-0" name="CaretLeft" size={14} />
      <Link
        className="shrink-0 transition hover:text-primary"
        href={`/hotel/${hotel.city.iata}/`}
      >
        رزرو هتل های {hotel.city.name}
      </Link>
      <PhosphorIcon className="shrink-0" name="CaretLeft" size={14} />
      <span className="truncate font-semibold text-primary" aria-current="page">
        {hotel.name}
      </span>
    </nav>
  );
}
